<template lang="pug">
div
  app-divider(label="Documentos", :showBorder="true", :addMarginTop="addMarginTop")
  el-table(
    :data="documentos"
  )
    el-table-column(label="Nome do arquivo:", :formatter="getName", min-width="280")
    el-table-column(label="Tipo de documento", :formatter="getTipoDocumento", min-width="250")
    el-table-column(label="Ações", prop="quantidadeUPFPA", width="80")
      template(slot-scope='scope')
        app-action-button(
          icone="download",
          text="Download",
          fontSize="18",
          @click="getDownload(scope.row)"
          posicaoTooltip="left"
        )

</template>
<script>
import FileSaver from 'file-saver'
import { mapActions, mapGetters } from 'vuex'
import AppActionButton from '@/components/AppActionButton'
import AppDivider from '@/components/AppDivider'

export default {
  props: {
    documentos: {
      Type: Array,
      required: true
    },
    addMarginTop: {
      Type: Boolean,
      default: true
    }
  },

  data () {
    return {
      isLoading: false,
      conteudoModal: '',
      conteudoModalSemid: null,
      tituloModal: '',
      isImagem: false,
      tipoModal: '',
      showModalVisualizaPdf: false
    }
  },

  components: {
    AppActionButton,
    AppDivider
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    })
  },

  methods: {
    ...mapActions({
      getDowloadDocument: 'download/downloadDocument'
    }),
    async getDownload (documento) {
      const file = await this.getDowloadDocument(documento)
      FileSaver.saveAs(file, documento.fileName)
    },
    getTipoDocumento (row) {
      return row.tipo?.nome || row.tipo?.descricao
    },
    getName (row) {
      return row.nome || row.fileName
    }

  }
}
</script>
<style lang="scss" scoped>
.pad5 {
  padding: 25px 10px;
}

</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/retificacao/components/resumos/AppResumoDocumentos.vue